import React from "react";
import * as S from "../styles";
import { InputWrapper } from "../../../components/InputWrapper";
import { DSInput } from "../../../components/DSInput";
import { formatNumberToPtBr } from "../utils";
import { ClientInfoProps } from "./types";

export const ClientInfo = ({
  name,
  creditCardNumber,
  currentInvoiceValue,
  debitBalance,
}: ClientInfoProps) => {
  const clientFields = [
    {
      name: "clientName",
      label: "Nome",
      value: name,
    },
    {
      name: "creditCard",
      label: "Cartão",
      value: creditCardNumber,
    },
    {
      name: "invoiceValue",
      label: "Fatura atual (R$)",
      value: formatNumberToPtBr(currentInvoiceValue),
    },
    {
      name: "debitBalance",
      label: "Saldo devedor (R$)",
      value: formatNumberToPtBr(debitBalance),
    },
  ];

  return (
    <S.CommonSection>
      <S.SectionTitle>Dados do cliente</S.SectionTitle>
      <S.ClientInfoFieldsWrapper>
        {clientFields.map((field) => (
          <InputWrapper
            label={field.label}
            name={field.name}
            key={`client-info-${field.name}`}
          >
            <DSInput value={field.value} name={field.name} disabled />
          </InputWrapper>
        ))}
      </S.ClientInfoFieldsWrapper>
    </S.CommonSection>
  );
};
